import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

function DeptSetting_View({ listpod_getcount,row,onclick_PODSorting, onclick_PODEdit ,onclick_PODDel,isPermissionEdit,isPermissionDel}) {

    return (

      <TableRow > 
          <TableCell>{row.rowindex}</TableCell>
          <TableCell>
            <div>{row.dept_name}</div>
          </TableCell>
          <TableCell className="text-center py-0 align-middle">
            {(isPermissionEdit) &&
              <div className="btn-group btn-group-sm">
                {row.rowindex !== 1 && row.rowindex !== 2 &&
                  <a href="#!" data-toggle="pill" title="up" onClick={() => onclick_PODSorting(row.pro_dept_id , "up")} >
                    <i className="fas fa-arrow-alt-circle-up fa-lg" />
                  </a>
                }
                {row.rowindex !== listpod_getcount.length && row.rowindex !== 1 &&
                  <a href="#!" data-toggle="pill" title="down" onClick={() => onclick_PODSorting(row.pro_dept_id , "down")} >
                    <i className="fas fa-arrow-alt-circle-down fa-lg" />
                  </a>
                }
              </div>
            }
          </TableCell>
          <TableCell className="text-right py-0 align-middle">
            <div className="btn-group btn-group-sm">
              {(isPermissionEdit) &&
                <a
                  href="#!"
                  className="btn btn-primary"
                  title="Edit"
                  // data-target="#modal-department"
                  // data-toggle="modal"
                  onClick={(event) => onclick_PODEdit(event,row.pro_dept_id , row.dept_name)}
                >
                  <i className="fas fa-pencil-alt" />
                </a>
              }
              {row.rowindex !== 1 && isPermissionDel &&
                <a
                  href="#!"
                  className="btn btn-default"
                  title="ลบ"
                  data-toggle="pill"
                  onClick={() => onclick_PODDel(row.pro_dept_id )}
                >
                  <i className="fas fa-trash" />
                </a>
              }
            </div>
          </TableCell>
        </TableRow>
  
    );
  };
  
  export default DeptSetting_View